<template>
  <div class="my-banner">
    <div class="box-banner">
      <div class="banner-img">
        <div style="display: flex;align-items: center;">
          <img src="./../static/px-logo.png" alt="" style="width: 70px;">
          <img src="./../static/px-banner (3).png" alt="" style="width: 431px;height: 63px;">
        </div>
        <div style="margin-left:13%;">
          <el-input placeholder="搜索您想要的招投标信息" size="large" v-model="input" clearable style="width: 350px;" @keyup.enter="jump">
            <template #append>
              <el-button :icon="Search" @click="jump" style="height: 100%;background: #e3720d;;color: #fff;display: flex;">搜索</el-button>
            </template>
          </el-input>
        </div>
        <div style="font-size:16px;color: rgb(93 110 110);font-weight: 600;">
          <span>技术支持：15230858186/17732191156</span><br>
          <span>工作时间：工作日9:00-12:00，14:00-17:30</span>
        </div>
      </div>
    </div>
    <div class="banner-banner">
      <div class="banner-list">
        <span class="banner-text" v-for="item in bannerArr" :key="item.id" @click="Jump(item)">{{ item.categoryName }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { getAllNavList } from "@/api/index.js"
import { Search } from '@element-plus/icons-vue'
let router = useRouter()
let input = ref('')
let bannerArr = ref([])
let Jump = (row) => {
  if (row.categoryType == 3) {
    window.open(row.link, '_blank')
  } else {
    router.push({ path: row.link })
  }
}
let jump = () => {
  router.push({ path: '/platformAnnouncements', query: { value: input.value } }).then(() => {
    input.value = ''
    location.reload()
  })
}
onMounted(async () => {
  await getAllNavList().then(res => {
    bannerArr.value = res.data
  })
})
</script>
<style scoped>
::v-deep .el-icon {
  font-size: 18px;
}
::v-deep .el-button--small {
  --el-button-size: 30px;
}
.my-banner {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.box-banner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.banner-img {
  width: 1400px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.banner-banner {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
      90deg,
      rgba(219, 36, 28, 1) 0%,
      rgba(235, 132, 39, 1) 100%
    ),
    linear-gradient(180deg, rgba(139, 39, 41, 1) 0%, rgba(231, 31, 25, 1) 100%);
  box-shadow: 0px 1px 2px rgba(60, 64, 67, 0.5),
    0px 2px 6px 2px rgba(60, 64, 67, 0.5);
}
.banner-list {
  width: 1300px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.banner-text {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  position: relative;
}
.banner-text:hover {
  font-weight: 700;
}
.banner-text::after {
  content: "";
  position: absolute;
  right: 0;
  top: 2px;
  width: 2px;
  opacity: 0.2;
  height: 24px;
  background: rgba(255, 255, 255, 0.7);
}
.banner-text:last-child::after {
  content: none;
}
.lines:before {
  content: "";
  display: block;
  width: 1px;
  height: 40px;
  background: #aaaaaa;
  position: absolute;
  left: -15px;
  top: 8px;
}
</style>